import { defineAttrs as C } from "../../utils/typed-attrs.js";
function b(t) {
  return t.replace(/([A-Z])/g, "-$1").toLowerCase();
}
function m() {
  const t = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  t.setAttribute("class", "h-4 w-4 align-middle -mt-0.5 fill-current"), t.setAttribute("viewBox", "0 0 16 16"), t.setAttribute("xmlns", "http://www.w3.org/2000/svg");
  const a = document.createElementNS("http://www.w3.org/2000/svg", "path");
  a.setAttribute(
    "d",
    "M11.4 3.4C11.07 3.07 10.53 3.07 10.2 3.4C9.87 3.73 9.87 4.27001 10.2 4.60001L13.6 8L10.2 11.4C9.87 11.73 9.87 12.27 10.2 12.6C10.37 12.77 10.58 12.85 10.8 12.85C11.02 12.85 11.24 12.77 11.4 12.6L16 8L11.4 3.4ZM2.4 8L5.8 4.60001C6.13 4.27001 6.13 3.73 5.8 3.4C5.47 3.07 4.93 3.07 4.6 3.4L0 8L4.6 12.6C4.77 12.77 4.98 12.85 5.2 12.85C5.42 12.85 5.64 12.77 5.8 12.6C6.13 12.27 6.13 11.73 5.8 11.4L2.4 8ZM6.25 6.75C5.56 6.75 5 7.31 5 8C5 8.69 5.56 9.25 6.25 9.25C6.94 9.25 7.5 8.69 7.5 8C7.5 7.31 6.94 6.75 6.25 6.75ZM11 8C11 7.31 10.44 6.75 9.75 6.75C9.06 6.75 8.5 7.31 8.5 8C8.5 8.69 9.06 9.25 9.75 9.25C10.44 9.25 11 8.69 11 8Z"
  ), t.appendChild(a);
  const n = document.createElement("span");
  return n.setAttribute("class", "inline-block align-middle"), n.appendChild(t), n;
}
function h() {
  const t = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  t.setAttribute("class", "h-4 w-4 align-middle -mt-0.5 fill-current"), t.setAttribute("viewBox", "0 0 16 16"), t.setAttribute("xmlns", "http://www.w3.org/2000/svg");
  const a = document.createElementNS("http://www.w3.org/2000/svg", "path");
  a.setAttribute(
    "d",
    "M12.8498 6.20986L7.99984 1.35986L3.14984 6.20986C2.81984 6.53986 2.81984 7.07986 3.14984 7.40986C3.47984 7.73986 4.01984 7.73986 4.34984 7.40986L7.14984 4.60986V13.9999H8.84984V4.60986L11.6498 7.40986C11.8198 7.57986 12.0298 7.65986 12.2498 7.65986C12.4698 7.65986 12.6898 7.57986 12.8498 7.40986C13.1798 7.07986 13.1798 6.53986 12.8498 6.20986Z"
  ), t.appendChild(a);
  const n = document.createElement("span");
  return n.setAttribute("class", "inline-block align-middle"), n.appendChild(t), n;
}
function w() {
  const t = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  t.setAttribute("class", "h-4 w-4 align-middle -mt-0.5 fill-current"), t.setAttribute("viewBox", "0 0 16 16"), t.setAttribute("xmlns", "http://www.w3.org/2000/svg");
  const a = document.createElementNS("http://www.w3.org/2000/svg", "path");
  a.setAttribute(
    "d",
    "M3.65992 12.1298C3.78992 12.2098 3.93992 12.2398 4.07992 12.2398C4.36992 12.2398 4.65992 12.0898 4.81992 11.8098L7.19992 7.69982C7.42992 7.28982 7.29992 6.76982 6.88992 6.53982C5.81992 5.91982 5.45992 4.55982 6.06992 3.48982C6.68992 2.41982 8.05992 2.05982 9.11992 2.66982C9.75992 3.03982 10.1799 3.70982 10.2299 4.44982C10.2599 4.91982 10.6599 5.26982 11.1399 5.23982C11.6099 5.20982 11.9599 4.79982 11.9299 4.32982C11.8399 3.01982 11.1099 1.84982 9.96992 1.19982C8.08992 0.119824 5.67992 0.759824 4.59992 2.63982C4.06992 3.54982 3.92992 4.60982 4.20992 5.61982C4.40992 6.34982 4.80992 6.99982 5.35992 7.49982L3.35992 10.9598C3.12992 11.3698 3.25992 11.8898 3.66992 12.1198L3.65992 12.1298ZM15.3199 9.42982C14.7899 8.51982 13.9499 7.86982 12.9299 7.59982C12.1999 7.39982 11.4399 7.42982 10.7299 7.64982L8.72992 4.18982C8.49992 3.77982 7.97992 3.63982 7.56992 3.87982C7.15992 4.11982 7.01992 4.62982 7.25992 5.03982L9.63992 9.14982C9.68992 9.23982 9.75992 9.30982 9.83992 9.37982C9.85992 9.39982 9.87992 9.40982 9.89992 9.42982C9.97992 9.47982 10.0599 9.52982 10.1499 9.54982C10.1499 9.54982 10.1499 9.54982 10.1599 9.54982C10.2299 9.56982 10.3099 9.57982 10.3799 9.57982C10.3999 9.57982 10.4299 9.57982 10.4499 9.57982C10.4699 9.57982 10.4999 9.57982 10.5199 9.57982C10.6199 9.55982 10.7199 9.53982 10.8099 9.47982C11.8799 8.85982 13.2499 9.22982 13.8599 10.2998C14.1599 10.8198 14.2399 11.4198 14.0799 11.9898C13.9199 12.5698 13.5599 13.0498 13.0399 13.3498C12.3999 13.7198 11.6099 13.7498 10.9399 13.4198C10.5199 13.2098 10.0099 13.3898 9.79992 13.8098C9.58992 14.2298 9.76992 14.7398 10.1899 14.9498C10.7399 15.2198 11.3199 15.3498 11.9099 15.3498C12.5899 15.3498 13.2699 15.1698 13.8799 14.8198C14.7899 14.2898 15.4399 13.4498 15.7099 12.4298C15.9799 11.4098 15.8399 10.3498 15.3199 9.44982V9.42982ZM12.7699 11.3898C12.7699 10.9198 12.3899 10.5398 11.9199 10.5398H7.16992C6.69992 10.5398 6.31992 10.9198 6.31992 11.3898C6.31992 12.6198 5.31992 13.6198 4.08992 13.6198C2.85992 13.6198 1.85992 12.6198 1.85992 11.3898C1.85992 10.6498 2.22992 9.94982 2.84992 9.53982C3.23992 9.27982 3.33992 8.74982 3.07992 8.35982C2.81992 7.96982 2.28992 7.86982 1.89992 8.12982C0.819922 8.85982 0.169922 10.0798 0.169922 11.3898C0.169922 13.5598 1.92992 15.3198 4.09992 15.3198C5.97992 15.3198 7.54992 13.9998 7.93992 12.2398H11.9399C12.4099 12.2398 12.7899 11.8598 12.7899 11.3898H12.7699Z"
  ), t.appendChild(a);
  const n = document.createElement("span");
  return n.setAttribute("class", "inline-block align-middle"), n.appendChild(t), n;
}
function g() {
  const t = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  t.setAttribute("class", "h-4 w-4 align-middle -mt-0.5 fill-current"), t.setAttribute("viewBox", "0 0 16 16"), t.setAttribute("xmlns", "http://www.w3.org/2000/svg");
  const a = document.createElementNS("http://www.w3.org/2000/svg", "path");
  a.setAttribute(
    "d",
    "M14.59 7.92L8.26001 1.59C7.88001 1.21 7.38001 1 6.85001 1H2.01001C1.46001 1 1.01001 1.45 1.01001 2V6.84C1.01001 7.37 1.22001 7.88 1.60001 8.25L7.92999 14.58C8.31999 14.97 8.95 14.97 9.34 14.58L14.59 9.33C14.98 8.94 14.98 8.31 14.59 7.92ZM4.25 5.5C3.56 5.5 3 4.94 3 4.25C3 3.56 3.56 3 4.25 3C4.94 3 5.5 3.56 5.5 4.25C5.5 4.94 4.94 5.5 4.25 5.5Z"
  ), t.appendChild(a);
  const n = document.createElement("span");
  return n.setAttribute("class", "inline-block align-middle"), n.appendChild(t), n;
}
function A() {
  const t = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  t.setAttribute("class", "h-4 w-4 align-middle -mt-0.5 fill-current"), t.setAttribute("viewBox", "0 0 16 16"), t.setAttribute("xmlns", "http://www.w3.org/2000/svg");
  const a = document.createElementNS("http://www.w3.org/2000/svg", "path");
  a.setAttribute(
    "d",
    "M14.24 1H8.25C4.52 1 1.5 4.02 1.5 7.75C1.5 11.48 4.52 14.5 8.25 14.5C11.98 14.5 15 11.48 15 7.75V1.76C15 1.34 14.66 1 14.24 1ZM12.01 9.12C12.01 9.59 11.63 9.97 11.16 9.97C10.69 9.97 10.31 9.59 10.31 9.12V6.88L6.39 10.8L5.19 9.6L9.11 5.68H6.88C6.41 5.68 6.03 5.3 6.03 4.83C6.03 4.36 6.41 3.98 6.88 3.98H12.02V9.11L12.01 9.12Z"
  ), t.appendChild(a);
  const n = document.createElement("span");
  return n.setAttribute("class", "inline-block align-middle"), n.appendChild(t), n;
}
function r(t, a = []) {
  const n = document.createElement("span");
  return n.textContent = t ?? "", a.length > 0 && n.setAttribute("class", a.join(" ")), n;
}
const f = C({
  operation: { default: "" },
  // read_attribute, update_attribute, or use_action
  subjectIdentifier: { default: "" },
  // intercom attribute key, local attribute id, or action id
  attributeType: { default: "" },
  attributeValue: { default: "" },
  attributeValueType: { default: "" }
  // actionInputs: { default: {} },
}), L = {
  inline: !0,
  group: "inline",
  selectable: !0,
  atom: !0,
  attrs: f,
  parseDOM: [
    {
      tag: "span[data-ai-prompt-data]",
      getAttrs(t) {
        return {
          operation: t.getAttribute("data-prompt-data-operation") ?? "",
          subjectIdentifier: t.getAttribute("data-prompt-data-subject-identifier") ?? "",
          attributeType: t.getAttribute("data-prompt-data-attribute-type") ?? "",
          attributeValue: t.getAttribute("data-prompt-data-attribute-value") ?? "",
          attributeValueType: t.getAttribute("data-prompt-data-attribute-value-type") ?? ""
        };
      }
    }
  ],
  toDOM(t) {
    const a = t.attrs, { operation: n } = a;
    let { subjectIdentifier: c } = a;
    const e = document.createElement("span");
    e.setAttribute("data-ai-prompt-data", ""), Object.entries(a).forEach(([l, s]) => {
      if (s) {
        const i = b(l);
        e.setAttribute(`data-prompt-data-${i}`, String(s));
      }
    });
    let o = ["ai-prompt-data-node"];
    if (n === "read_attribute") {
      const l = m();
      e.appendChild(l);
      const s = r("Read:", ["prompt-data-label"]);
      if (e.appendChild(s), !c) {
        const u = r("Select attribute");
        return e.appendChild(u), o = [...o, "prompt-data-error", "selectable"], e.setAttribute("class", o.join(" ")), e;
      }
      const i = this.infoResolver, d = i == null ? void 0 : i.humanReadable(c), p = r(d);
      return e.appendChild(p), e.setAttribute("class", o.join(" ")), e;
    }
    if (n === "update_attribute") {
      const l = h();
      e.appendChild(l);
      const s = r("Update:", ["prompt-data-label"]);
      if (e.appendChild(s), !c) {
        const u = r("Select attribute");
        return e.appendChild(u), o = [...o, "prompt-data-error"], e.setAttribute("class", o.join(" ")), e;
      }
      const i = this.infoResolver, d = i == null ? void 0 : i.humanReadable(c), p = r(d);
      return e.appendChild(p), e.setAttribute("class", o.join(" ")), e;
    }
    if (n === "use_action") {
      const l = w();
      e.appendChild(l);
      const s = r("Use:", ["prompt-data-label"]);
      if (e.append(s), !c) {
        const u = r("Select data connector");
        return e.appendChild(u), o = [...o, "prompt-data-error", "selectable"], e.setAttribute("class", o.join(" ")), e;
      }
      const i = this.infoResolver, d = i == null ? void 0 : i.humanReadable(c), p = r(d);
      return e.appendChild(p), e.setAttribute("class", o.join(" ")), e;
    }
    if (n === "add_tag_to_conversation") {
      const l = g();
      e.appendChild(l);
      const s = r("Tag conversation:", ["prompt-data-label"]);
      if (e.append(s), !c) {
        const u = r("Select conversation to tag");
        return e.appendChild(u), o = [...o, "prompt-data-error", "selectable"], e.setAttribute("class", o.join(" ")), e;
      }
      const i = this.commandsResolver, d = i == null ? void 0 : i.humanReadable(c), p = r(d);
      return e.appendChild(p), e.setAttribute("class", o.join(" ")), e;
    }
    if (n === "escalate_conversation") {
      const l = A();
      e.appendChild(l);
      const s = r("Escalate to:", ["prompt-data-label"]);
      e.append(s), c || (a.subjectIdentifier = "assignee.DEFAULT", a.attributeValueType = "fin", e.setAttribute("data-prompt-data-subject-identifier", "assignee.DEFAULT"), e.setAttribute("data-prompt-data-attribute-value-type", "fin"), c = "assignee.DEFAULT");
      const i = this.commandsResolver, d = i == null ? void 0 : i.humanReadable(c), p = r(d);
      return e.appendChild(p), e.setAttribute("class", o.join(" ")), e;
    }
    throw new Error(`Unknown prompt data operation: ${n}`);
  }
};
export {
  L as aiPromptDataSpec
};
